export function isInvalidField(field) {
  if (!field.$dirty) {
    return false
  }
  return field.$invalid
}